import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { MattRow } from '../../../../components/containers/containers';
import {
  Direction,
  PortfolioFinancialInstrument,
  PortfolioFundamental,
  PortfolioFunds,
} from '../../../../logic/graphql/types/types.d';
import ExchangeOrders from '../../../../logic/redux/exchange-orders';
import { Paths } from '../../../../navigation/paths';
import {
  FinancialInstrumentContent,
  FinancialInstrumentMobileContent,
  FundsContent,
  FundsMobileContent,
} from './components';

const Container = styled(MattRow)`
  display: none;
  padding: 0px 30px;
  cursor: pointer;
  height: 84px;
  width: 100%;
  background: var(--blur-bg-color);
  margin-bottom: 10px;
  flex-direction: row;
  align-items: center;
  @media (min-width: 768px) {
    display: flex;
  }
`;

const MobileContainer = styled(MattRow)`
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 10px;
  cursor: pointer;
  width: 100%;
  background: var(--blur-bg-color);
  margin-bottom: 10px;
  display: flex;
  @media (min-width: 768px) {
    display: none;
  }
`;

const InstrumentListItem = (props: { fundamental: PortfolioFundamental }): JSX.Element => {
  const history = useHistory();
  const dispatch = useDispatch();
  const typeName = (props.fundamental as PortfolioFundamental & { __typename: string })?.__typename;

  const handleOnClick = (): void => {
    switch (typeName) {
      case 'PortfolioFinancialInstrument': {
        const financialInstrument = props.fundamental as PortfolioFinancialInstrument;
        if (financialInstrument.tradable_stock_exchange) {
          dispatch(
            ExchangeOrders.actions.setEditedExchangeOrder({
              direction: Direction.Sell,
              security: financialInstrument.security.short_name,
              securityDetails: financialInstrument.security,
              account: financialInstrument.accounts[0]?.number,
              accountDetails: financialInstrument.accounts[0],
            }),
          );
          history.push(Paths.new_exchange_order);
        } else {
          history.push(Paths.contact);
        }
        break;
      }
      case 'PortfolioFunds': {
        const funds = props.fundamental as PortfolioFunds;
        dispatch(
          ExchangeOrders.actions.setEditedExchangeOrder({
            direction: Direction.Buy,
            account: funds.accounts[0]?.number,
            accountDetails: funds.accounts[0],
          }),
        );
        history.push(Paths.new_exchange_order);
        break;
      }
      default:
        return;
    }
  };

  const renderContent = (): JSX.Element | null => {
    switch (typeName) {
      case 'PortfolioFinancialInstrument':
        return (
          <FinancialInstrumentContent
            instrument={props.fundamental as PortfolioFinancialInstrument}
          />
        );
      case 'PortfolioFunds':
        return <FundsContent funds={props.fundamental as PortfolioFunds} />;
      default:
        return null;
    }
  };

  const renderMobileContent = (): JSX.Element | null => {
    switch (typeName) {
      case 'PortfolioFinancialInstrument':
        return (
          <FinancialInstrumentMobileContent
            instrument={props.fundamental as PortfolioFinancialInstrument}
          />
        );
      case 'PortfolioFunds':
        return <FundsMobileContent funds={props.fundamental as PortfolioFunds} />;
      default:
        return null;
    }
  };

  return (
    <>
      <Container onClick={handleOnClick}>{renderContent()}</Container>
      <MobileContainer onClick={handleOnClick}>{renderMobileContent()}</MobileContainer>
    </>
  );
};

export default InstrumentListItem;
